module.exports = __webpack_public_path__ + "img/icone-john-deere-connected-white.f83c6697.svg";